import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const BookContent = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const actionButtons = [
        {
            id: "begin-reading",
            onClick: () =>
                navigate("/pages", { state: { book: location.state.book } }),
            text: "Begin Reading",
            className:
                "shadow-[inset_0px_-4px_15px_#7fab81] bg-[linear-gradient(0deg,rgba(181,255,43,0)_0%,rgba(115,197,48,0.2)_100%),linear-gradient(0deg,rgba(170,224,22,1)_0%,rgba(170,224,22,1)_100%)]",
            icon: (
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                        d="M27.75 2.7C27.04 2.1 26.2 1.68 25.3 1.45C24.4 1.22 23.46 1.19 22.55 1.37L20.35 1.9C19.2 2.12 18.16 2.73 17.41 3.62C16.66 4.52 16.25 5.66 16.25 6.83V26.16C15.42 26.28 14.58 26.28 13.75 26.16V6.83C13.75 5.67 13.35 4.54 12.62 3.65C11.88 2.75 10.86 2.14 9.72 1.92L7.38 1.35C6.47 1.19 5.55 1.22 4.66 1.46C3.78 1.69 2.95 2.11 2.25 2.7C1.54 3.29 0.98 4.02 0.59 4.85C0.2 5.68 0 6.58 0 7.5V21C0 22.45 0.51 23.87 1.45 24.99C2.39 26.12 3.69 26.88 5.13 27.14L12.99 28.57C14.32 28.81 15.68 28.81 17.01 28.57L24.88 27.14C26.31 26.88 27.61 26.12 28.55 24.99C29.49 23.87 30 22.45 30 21V7.5C30 6.58 29.8 5.68 29.41 4.85C29.02 4.02 28.45 3.29 27.75 2.7Z"
                        fill="#374957"
                    />
                </svg>
            ),
        },
        {
            id: "back-to-library",
            onClick: () => navigate("/library"),
            text: "Back to Library",
            className:
                "shadow-[inset_0px_-4px_15px_#edca92] bg-[linear-gradient(0deg,rgba(252,255,80,0)_0%,rgba(255,178,0,0.2)_100%),linear-gradient(0deg,rgba(255,238,192,1)_0%,rgba(255,238,192,1)_100%)]",
            icon: (
                <svg width="31" height="30" viewBox="0 0 31 30" fill="none">
                    <path
                        d="M1.6 17.61L6.44 22.5C6.55 22.62 6.69 22.71 6.84 22.77C6.99 22.84 7.16 22.87 7.33 22.87C7.49 22.87 7.65 22.84 7.81 22.77C7.96 22.71 8.1 22.62 8.21 22.5C8.33 22.38 8.42 22.25 8.49 22.09C8.55 21.94 8.58 21.78 8.58 21.61C8.58 21.45 8.55 21.28 8.49 21.13C8.42 20.98 8.33 20.84 8.21 20.72L3.76 16.25H29.25C29.58 16.25 29.9 16.12 30.13 15.88C30.37 15.65 30.5 15.33 30.5 15C30.5 14.67 30.37 14.35 30.13 14.12C29.9 13.88 29.58 13.75 29.25 13.75H3.69L8.21 9.22C8.43 8.99 8.56 8.68 8.56 8.36C8.56 8.04 8.43 7.73 8.21 7.5C8.1 7.38 7.96 7.29 7.81 7.23C7.65 7.16 7.49 7.13 7.33 7.13C7.16 7.13 6.99 7.16 6.84 7.23C6.69 7.29 6.55 7.38 6.44 7.5L1.6 12.31C0.9 13.02 0.5 13.97 0.5 14.96C0.5 15.96 0.9 16.91 1.6 17.61Z"
                        fill="#374957"
                    />
                </svg>
            ),
        },
    ];

    return (
        <div className="relative w-screen h-screen overflow-hidden bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,36,114,0.27)_100%),linear-gradient(180deg,rgba(53,104,162,1)_0%,rgba(32,67,118,1)_100%)] flex flex-col">
            {/* Background bookshelf image */}




            {/* Header */}
            <header className="flex items-center justify-center h-[10%] px-6 shadow-md bg-transparent z-10">
                <h1 className="text-3xl md:text-5xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
                    {location.state.book.title}
                </h1>
            </header>

            {/* Main */}
            <main className="flex flex-col md:flex-row flex-1 items-center justify-center gap-12 p-6">
                <section className="relative flex-1 self-stretch w-full grow rounded-[20px] overflow-hidden bg-[linear-gradient(0deg,rgba(250,246,232,1)_0%,rgba(250,246,232,1)_100%)]">
                    <div className="relative w-full h-full flex flex-col md:flex-row items-center justify-around p-6 md:p-12 gap-12">
                        <div className="absolute w-full h-full top-0 left-0">
                            <img
                                src={location.state.book.coverImage || "/images/imagebook.png"}
                                alt="Background shelf with books"
                                className="absolute inset-0 w-full h-full object-cover -z-0"
                            />
                        </div>

                        {/* Overlay tint for readability */}
                        <div className="absolute inset-0 bg-[#faf6e8e6] z-1" />

                        {/* Book Cover */}
                        <figure className="flex-shrink-0 w-48 md:w-72 lg:w-86 z-2">
                            <img
                                className="w-full h-auto object-cover rounded-lg shadow-lg"
                                alt={`Book cover for ${location.state.book.title}`}
                                src={location.state.book.coverImage || "/images/image.png"}
                            />
                        </figure>

                        {/* Actions */}
                        <nav
                            className="flex flex-col gap-6 w-full md:w-[400px] z-3"
                            role="navigation"
                            aria-label="Book actions"
                        >
                            {actionButtons.map((button) => (
                                <button
                                    key={button.id}
                                    onClick={button.onClick}
                                    className={`flex items-center gap-4 px-6 py-4 ${button.className} text-[#374957] rounded-full text-xl md:text-2xl font-medium shadow-button hover:shadow-lg transition-all`}
                                    type="button"
                                    aria-label={button.text}
                                >
                                    {button.icon}
                                    <span>{button.text}</span>
                                </button>
                            ))}
                        </nav>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default BookContent;
